<template>
  <div class="execution">
    <div class="course-group-filter">
      <el-row>
         <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="course-group-filter-value" placeholder="课程分组名称" v-model.trim="name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="course-group-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="course-group-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 v-model="form"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @on-load="getList"
                 @row-update="handleUpdate"
                 @row-save="handleSave"
                 @search-change="searchChange"
                 @row-del="rowDel">

        <template slot="groupDescription" slot-scope="scope">{{scope.row.groupDescription ? scope.row.groupDescription : "--"}}</template>
        <template slot="groupDescriptionEn" slot-scope="scope">{{scope.row.groupDescriptionEn ? scope.row.groupDescriptionEn : "--"}}</template>

        <template slot="icon" slot-scope="scope">
           <div class="icon">
             <div class="icon-image" v-if="scope.row.icon" v-viewer>
              <img :src="scope.row.icon | ossImageProcess">
            </div>
           </div>
        </template>

        <template slot="iconForm" slot-scope="scope">
          <div>
            <div>
              <div v-if="form.icon" class="group-iconUrl-wrapper">
                <img class="group-icon-image" :src="form.icon | ossImageProcess">
                <el-button type="text" @click="form.icon = ''" icon="icon-remove-image" class="image-remove-icon"></el-button>
              </div>
              <el-button v-else type="text" @click="handleListPageImageChange(form)" icon="icon-add-cover" class="add-cover"></el-button>
              <div class="hint">推荐尺寸为64×64像素,支持jpg、jpeg、png格式</div>
            </div>
          </div>  
        </template>

        <template slot="sortForm" slot-scope="scope">
          <div>
            <el-input-number controls-position="right" v-model="form.sort" :precision="0"></el-input-number>
            <div class="hint tips-info" >提示：数字越大优先级越高</div>
          </div>
        </template>

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.course_group_add">新增</el-button>
        </template>

        <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     v-if="permissions.course_group_update"
                     size="mini"
                     @click="handleEdit(scope.row,scope.index)">编辑
          </el-button>
          <el-button type="text"
                     v-if="permissions.course_group_delete"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">删除
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.course_group_update"
                     @click="handleSwitchTop(scope.row,scope.index,true)">置顶
          </el-button>
          <el-button size="mini"
                     type="text"
                     v-if="permissions.course_group_update && scope.row.sort > 0"
                     @click="handleSwitchTop(scope.row,scope.index,false)">取消置顶
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import {fetchCourseGroupList, addCourseGroup, editCourseGroup, removeCourseGroupById, updateCourseGroupTopStatus} from '@/api/app/course';
import {courseGroupTableOption} from '@/const/crud/app/course'
import {mapGetters} from 'vuex';

  export default {
    name: 'course-group',
    data() {
      return {
        tableData: [],
        tableLoading: false,
        tableOption: courseGroupTableOption,
        name: '',
      }
    },
    created() {
    },
    mounted: function () {
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      handleListPageImageChange(row) {
        this.$openMaterialLib((list) => {
          if (list && list.length > 0) {
            row.icon = list[0].contentUrl;
          }
          this.$refs.ruleForm.validateField('icon');
        }, 1);
      },
      getList() {
        this.tableLoading = true;
        let params = {
          name: this.name,
        };
        fetchCourseGroupList(params).then(response => {
          this.tableData = response.data.data;
          this.tableLoading = false;
        })
      },
      handleAdd() {
        this.$refs.crud.rowAdd();
      },
      handleEdit(row, index) {
        this.$refs.crud.rowEdit(row, index);
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index);
      },
      handleSwitchTop (row, index, isTop) {
        let params = {
          isTop: isTop,
        }
        this.$confirm('是否' + (isTop? '置顶' : '取消置顶') + '该课程分组?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateCourseGroupTopStatus(row.id, params).then(response => {
            if (response.data.data) {
              this.$message({
                message: (isTop ? '置顶' : '取消置顶') + '成功',
                type: 'success'
              })
              this.getList(this.page);
            }
          }).catch(error => {
            this.$message({
              message: (isTop ? '置顶' : '取消置顶') + '失败',
              type: 'error'
            })
          })
        })
      },
      async rowDel (row, index) {
        var _this = this;
        this.$confirm('是否确认删除分组名为"' + row.groupName + '"的课程分组?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async function () {
          const response = await _this.requestWrapper(removeCourseGroupById, row.id);
          if (!response || response.ok === false) {
            _this.$message({
              showClose: true,
              message: response.message || '删除失败',
              type: 'error',
            });
            return;
          }

          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          _this.getList();
        }).catch(function (err) {
        })
      },
      /**
       * @title 数据更新
       * @param row 为当前的数据
       * @param index 为当前更新数据的行数
       * @param done 为表单关闭函数
       *
       **/
      async handleUpdate (row, index, done, loading) {
        let params = {
          id: row.id,
          groupName: row.groupName,
          groupNameEn: row.groupNameEn,
          groupDescription: row.groupDescription,
          groupDescriptionEn: row.groupDescriptionEn,
          sort: row.sort,
          icon: row.icon,
        }
        const response = await this.requestWrapper(editCourseGroup, params);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || '修改失败',
            type: 'error',
          });
          loading();
          return;
        }

        this.$message({
          showClose: true,
          message: '修改成功',
          type: 'success'
        })
        this.getList();
        done();
      },
      /**
       * @title 数据添加
       * @param row 为当前的数据
       * @param done 为表单关闭函数
       *
       **/
      async handleSave (row, done, loading) {
        let params = {
          groupName: row.groupName,
          groupNameEn: row.groupNameEn,
          groupDescription: row.groupDescription,
          groupDescriptionEn: row.groupDescriptionEn,
          sort: row.sort,
          icon: row.icon,
        }
        const response = await this.requestWrapper(addCourseGroup, params);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || '添加失败',
            type: 'error',
          });
          loading();
          return;;
        }

        this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success'
        })
        this.getList();
        done()
      },
      searchChange() {
        this.getList();
      },
      searchReset() {
      this.name = '';
      this.searchChange();
    },
    }
  }
</script>

<style lang="scss" scoped>
.course-group-filter {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border: none;
    font-size: 14px;
  }
  .el-row {
    width: 95%;
  }
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;
  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
.el-form .hint {
  font-size: 12px;
  line-height: 2;
  color: #7D7D7D;
}

.add-cover {
  padding-bottom: 0;
}

.icon .icon-image img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  max-width: 100%;
}
.group-iconUrl-wrapper {
  position: relative;
  width: 54px;

  .group-icon-image {
    margin-top: 10px;
    width: 54px;
  }

  .image-remove-icon {
    position: absolute;
    top: 0;
    right: -20px;
  }
}
</style>
